/* -------------------------------------------------------------------------- */
/*                               Project types                                */
/* -------------------------------------------------------------------------- */

/**
 * Array of unit objects with unique IDs and corresponding labels.
 * @type {Array<{ id: string, value: string,label: string, image: string }>}
 */
export const PROJECT_TECHNOLOGIES = [
	{
		id: 'THERMAL_SOLAR',
		value: 'THERMAL_SOLAR',
		label: `global.technologies.thermalSolar`,
		image:
			'https://res.cloudinary.com/dirpe8qjq/image/upload/v1706631630/Inuk/kisixfekefcvey4jq3xm.jpg',
	},
	{
		id: 'PHOTOVOLTAIC',
		value: 'PHOTOVOLTAIC',
		label: `global.technologies.photovoltaic`,
		image:
			'https://res.cloudinary.com/dirpe8qjq/image/upload/v1706631630/Inuk/lrgllsm4vk1qs2lknpgt.jpg',
	},
	{
		id: 'WIND',
		value: 'WIND',
		label: `global.technologies.wind`,
		image:
			'https://res.cloudinary.com/dirpe8qjq/image/upload/v1706631630/Inuk/h0tsjmdbnzxceotdzsxe.jpg',
	},
	{
		id: 'BIOMASS',
		value: 'BIOMASS',
		label: `global.technologies.biomass`,
		image: 'https://www.inuk.co/static/img/Narbosol.png',
	},
	{
		id: 'HEAT_PUMP',
		value: 'HEAT_PUMP',
		label: `global.technologies.heatPump`,
		image:
			'https://res.cloudinary.com/dirpe8qjq/image/upload/v1706631630/Inuk/ottpo36igu215arotz89.jpg',
	},
	{
		id: 'LOW_CARBON_MATERIAL',
		value: 'LOW_CARBON_MATERIAL',
		label: `global.technologies.lowCarbonMaterial`,
		image: 'https://www.inuk.co/static/img/Alleyne.png',
	},
	{
		id: 'FATAL_HEAT',
		value: 'FATAL_HEAT',
		label: `global.technologies.fatalHeat`,
		image: 'https://www.inuk.co/static/img/Alleyne.png',
	},

	{
		id: 'PROJECT_FOUNDER',
		value: 'PROJECT_FOUNDER',
		label: `global.technologies.projectFounder`,
		image: 'https://www.inuk.co/static/img/Alleyne.png',
	},
	{
		id: 'UNSPECIFIED',
		value: 'UNSPECIFIED',
		label: `global.technologies.unspecified`,
		image: 'https://www.inuk.co/static/img/Alleyne.png',
	},
	{
		id: 'CIRCULARITY',
		value: 'CIRCULARITY',
		label: `global.technologies.circularity`,
		image: 'https://www.inuk.co/static/img/Narbosol.png',
	},
];
